var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout"},[_c('TheHeader',{attrs:{"scrollY":0}}),_c('div',{staticClass:"page"},[_vm._t("default")],2),_c('TheFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }